import { render, staticRenderFns } from "./NewSiblingItemForm.vue?vue&type=template&id=71f0cddc&scoped=true&"
import script from "./NewSiblingItemForm.vue?vue&type=script&lang=js&"
export * from "./NewSiblingItemForm.vue?vue&type=script&lang=js&"
import style0 from "./NewSiblingItemForm.vue?vue&type=style&index=0&id=71f0cddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f0cddc",
  null
  
)

export default component.exports